import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAuthToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        // Persist Bearer token for browsers that block cross-site cookies
        // (Safari ITP). Without this, every authenticated request after
        // Google login returns 401 on `gas2go.app` because the cookie
        // never reaches the backend. See AuthContext.persistToken.
        if (data?.auth_token) setAuthToken(data.auth_token);
        setUser(data);
        // Clean hash and go to app
        window.history.replaceState({}, document.title, window.location.pathname);
        if (data.role === "super_admin") navigate("/super-admin", { replace: true });
        else if (data.role === "company_admin") navigate("/admin", { replace: true });
        else navigate("/app", { replace: true });
      } catch (e) {
        navigate("/login?err=google", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-pulse text-sm text-neutral-500">Conectando con Google...</div>
    </div>
  );
}
